export default __webpack_public_path__ + "static/media/html.2081a783.png";